import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'
import { Comments } from '@one/types'

export class AppCommentsApi extends ApiServiceWithSettings {
  getDiscussion(
    id: string
  ): AxiosPromise<Comments.Backoffice.Responses.DiscussionRestView> {
    return this.get(`/discussions/${id}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.APP
    })
  }

  addAttachment(
    id: string,
    attachments: Comments.Backoffice.AddAttachmentRestCommand
  ): AxiosPromise<Comments.Backoffice.Responses.AttachmentsUploadUrlRestView> {
    return this.post(`/discussions/${id}/attachments`, attachments, {
      authentication: Authentication.REQUIRED,
      aud: Audience.APP
    })
  }

  addComment(
    id: string,
    comments: Comments.App.Request.AddCommentRestCommand
  ): AxiosPromise<{ commentIds: Array<string> }> {
    return this.post(`/discussions/${id}/comments`, comments, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  uploadAttachment(
    uploadUrl: string,
    formData: any,
    fileType: string
  ): AxiosPromise<void> {
    return this.put(uploadUrl, formData, {
      rawUrl: true,
      injectToken: false,
      injectTenant: false,
      headers: {
        'Content-Type': fileType
      }
    })
  }

  finishUpload(url: string): AxiosPromise<void> {
    return this.post(url, null, {
      rawUrl: true,
      injectToken: false,
      injectTenant: false
    })
  }
}
